module.exports = __webpack_public_path__ + "img/people11.40720f49.png";